import React from 'react'
import sport_type_initial_state from 'pages/Sport/_context/sport_initial_state'

export default React.createContext(sport_type_initial_state)
